import { Injectable, EventEmitter, Inject } from "@angular/core";
import { Http, Headers, RequestOptionsArgs } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { Router } from "@angular/router";
import { ACCOUNTS_URL, REST_API_REQUEST_CALL_URL, Util } from "../utils/index";
import { AlertService, Location, Corporation, Line } from "./index";
import * as bigdecimal from "bigdecimal";
import { ApiService } from "../services/api.service";
import {
  GetContextMenuItemsParams,
  MenuItemDef,
} from "ag-grid/dist/lib/entities/gridOptions";

declare var moment: any;

@Injectable()
export class FareService {
  initRowCnt: number = 500;

  private headers: Headers = new Headers({
    "Content-Type": "application/json",
  });

  changeLinerEmit: EventEmitter<any> = new EventEmitter();
  changeTransNmEmit: EventEmitter<any> = new EventEmitter();
  constructor(
    private router: Router,
    private http: Http,
    private alertService: AlertService,
    private apiService: ApiService
  ) {}

  chnagedLiner(data: any) {
    this.changeLinerEmit.emit(data);
  }
  getCostItem(): Observable<any> {
    return this.apiService
      .get(REST_API_REQUEST_CALL_URL.GET_COST_ITE_URL)
      .map((res) => {
        let jsonData = res;
        if (jsonData.result) {
          let data = jsonData.data;
          return data;
        } else {
          if (jsonData == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          }
          this.alertService.error(res.errorMsg);
          return null;
        }
      })
      .catch((error: any) => {
        this.alertService.error(
          "서버와 연결이 중단되었습니다.\n" + error.error || "Server error"
        );
        return Observable.throw("Server Error");
      });
  }

  getCnsltnMoveCntryRate(
    options: RequestOptionsArgs,
    reqNo: string
  ): Observable<any> {
    return this.apiService
      .get(REST_API_REQUEST_CALL_URL.GET_CONSULT_COUNTRY_RATE_URL + reqNo)
      .map((res) => {
        let jsonData = res;
        if (jsonData.result) {
          let data = jsonData.data;
          return data;
        } else {
          if (jsonData == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          }
          this.alertService.error(res.errorMsg);
          return null;
        }
      })
      .catch((error: any) => {
        this.alertService.error(
          "서버와 연결이 중단되었습니다.\n" + error.error || "Server error"
        );
        return Observable.throw("Server Error");
      });
  }

  getCnsltnReq(options: RequestOptionsArgs, reqNo: string): Observable<any> {
    return this.apiService
      .get(REST_API_REQUEST_CALL_URL.GET_CONSULT_REQ + reqNo)
      .map((res) => {
        let jsonData = res;
        if (jsonData.result) {
          let data = jsonData.data;
          return data;
        } else {
          if (jsonData == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          }
          this.alertService.error(res.errorMsg);
          return null;
        }
      })
      .catch((error: any) => {
        this.alertService.error(
          "서버와 연결이 중단되었습니다.\n" + error.error || "Server error"
        );
        return Observable.throw("Server Error");
      });
  }

  postCnsltnQuot(data: any): Observable<any> {
    return this.apiService
      .post(REST_API_REQUEST_CALL_URL.POST_CONSULT_QUOT, data, true)
      .map((res) => {
        if (res.data && res.data.result.indexOf("success") > -1) {
          this.alertService.success("저장이 완료 되었습니다.");
          return res.data;
        } else {
          if (res.errorCode == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          }
          this.alertService.error(res.errorMsg);
          return null;
        }
      })
      .catch((error: any) => {
        this.alertService.error("서버와 연결이 중단되었습니다. \n");
        return Observable.throw(error.error || "Server error");
      });
  }

  getQuotation(params: any) {
    return this.apiService
      .get(
        REST_API_REQUEST_CALL_URL.GET_CONSULT_QUOT +
          params.reqNo +
          "/" +
          params.quotNo
      )
      .map((res) => {
        let jsonData = res;
        if (jsonData.result) {
          let data = jsonData.data;
          return data;
        } else {
          if (jsonData == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          }
          this.alertService.error(res.errorMsg);
          return null;
        }
      })
      .catch((error: any) => {
        this.alertService.error(
          "서버와 연결이 중단되었습니다.\n" + error.error || "Server error"
        );
        return Observable.throw("Server Error");
      });
  }

  getQuotRouteList(params: any) {
    return this.apiService
      .get(
        REST_API_REQUEST_CALL_URL.GET_QUOT_ROUTE_LIST_URL +
          params.reqNo +
          "/" +
          params.quotNo
      )
      .map((res) => {
        let jsonData = res;
        if (jsonData.result) {
          let data = jsonData.data;
          return data;
        } else {
          if (jsonData == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          }
          this.alertService.error(res.errorMsg);
          return null;
        }
      })
      .catch((error: any) => {
        this.alertService.error(
          "서버와 연결이 중단되었습니다.\n" + error.error || "Server error"
        );
        return Observable.throw("Server Error");
      });
  }

  getContextMenuItems(
    spliceCallBack?: (row: number) => void,
    pushCallBack?: () => void
  ): (params: GetContextMenuItemsParams) => (string | MenuItemDef)[] {
    return (params: GetContextMenuItemsParams) => {
      let result: (string | MenuItemDef)[] = [
        {
          name: "위에 1행 삽입",
          action: () => {
            if (params.node == null) {
              return;
            } else {
              let row = params.node.childIndex;
              spliceCallBack(row);
            }
          },
        },
        {
          name: "아래에 1행 삽입",
          action: () => {
            if (params.node == null) {
              return;
            } else {
              let row = params.node.childIndex;
              spliceCallBack(row + 1);
            }
          },
        },
        "separator",
        {
          name: "행 추가",
          action: () => {
            pushCallBack();
          },
        },
        {
          name: "5행 추가",
          action: () => {
            for (let i = 0; i < 5; i++) pushCallBack();
          },
        },
        "separator",
        "copy",
        "paste",
      ];
      return result;
    };
  }

  getTransFare(
    transType: TransType,
    body: TransFareConditionModel
  ): Observable<any> {
    let url: string = null;

    if (transType == TransType.FCL) url = "admin/fare/trans/fcl";
    else if (transType == TransType.LCL) url = "admin/fare/trans/lcl";
    else if (transType == TransType.AIR) url = "admin/fare/trans/air";

    if (url) return this.apiService.get(url, body);
    else return null;
  }

  getIncidFare(
    transType: TransType,
    body: IncidFareConditionModel
  ): Observable<any> {
    let url: string = null;

    if (transType == TransType.FCL) url = "admin/fare/incid/fcl";
    else if (transType == TransType.LCL) url = "admin/fare/incid/lcl";
    else if (transType == TransType.AIR) url = "admin/fare/incid/air";

    if (url) return this.apiService.get(url, body);
    else return null;
  }

  getIncidFareReq(
    transType: TransType,
    body: IncidFareConditionModel
  ): Observable<any> {
    let url: string = null;

    if (transType == TransType.FCL) url = "admin/fare/incidreq/fcl";
    else if (transType == TransType.LCL) url = "admin/fare/incidreq/lcl";
    else if (transType == TransType.AIR) url = "admin/fare/incidreq/air";

    if (url) return this.apiService.get(url, body);
    else return null;
  }

  applyIncidFareReq(fareIncidReqGrpId: number): Observable<any> {
    return this.apiService.post("admin/fare/incid/apply", {
      fareIncidReqGrpId: fareIncidReqGrpId,
    });
  }

  saveTransFare(
    transType: TransType,
    gridTransFareList: GridTransRouteFare[]
  ): Observable<any> {
    if (
      transType == null ||
      !gridTransFareList ||
      gridTransFareList.length <= 0
    )
      return null;

    let url: string = null;
    let fareList: RouteFareTrans[] = [];

    if (transType == TransType.FCL) url = "admin/fare/trans/fcl";
    else if (transType == TransType.LCL) url = "admin/fare/trans/lcl";
    else if (transType == TransType.AIR) url = "admin/fare/trans/air";

    for (let gridTransFare of gridTransFareList) {
      if (gridTransFare.isUpdate) fareList.push(gridTransFare.getFare());
    }

    let body = { fareList: fareList };
    return this.apiService.post(url, body);
  }

  saveIncidFare(gridIncidFareList: GridIncidRouteFare[]): Observable<any> {
    if (!gridIncidFareList || gridIncidFareList.length <= 0) return null;

    let url: string = null;
    let fareList: RouteFareIncid[] = [];

    for (let gridIncidFare of gridIncidFareList) {
      if (gridIncidFare.isUpdate) fareList.push(gridIncidFare.getFare());
    }

    let body = { fareList: fareList };
    return this.apiService.post("admin/fare/incid", body);
  }

  getFwdrTransFare(
    transType: TransType,
    coprId: number,
    body: TransFareConditionModel
  ): Observable<any> {
    let url: string = null;

    if (transType == TransType.FCL) url = "admin/fare/trans/" + coprId + "/fcl";
    else if (transType == TransType.LCL)
      url = "admin/fare/trans/" + coprId + "/lcl";
    else if (transType == TransType.AIR)
      url = "admin/fare/trans/" + coprId + "/air";

    if (url) return this.apiService.get(url, body);
    else return null;
  }

  getFwdrIncidFare(
    transType: TransType,
    coprId: number,
    body: IncidFareConditionModel
  ): Observable<any> {
    let url: string = null;

    if (transType == TransType.FCL) url = "admin/fare/incid/" + coprId + "/fcl";
    else if (transType == TransType.LCL)
      url = "admin/fare/incid/" + coprId + "/lcl";
    else if (transType == TransType.AIR)
      url = "admin/fare/incid/" + coprId + "/air";

    if (url) return this.apiService.get(url, body);
    else return null;
  }
}

export class CrncyRateModel {
  public cntryCd: string;
  public crncyCd: string;
  public stndDt: string;
  public krwPerUnit: bigdecimal;
  unitPerKrw: bigdecimal;
}

export class CostItemModel {
  public itemCd: string;
  public itemDesc: string;
  public itemNm: string;
}

export class CnsltnQuotCstModel {
  public reqNo: string;
  public itemCd: string;
  public itemNm: string;
  public itemUnit: string;
  public itemUnitCd: string;
  public cstTp: number;
  public crncyCd: string;
  public other: string;
  public cstTpNm: string;
  public cost: bigdecimal.BigDecimal;
  public unitCost: number;
  public chargeWm: bigdecimal.BigDecimal;
  public minUnitCost: number;
  // public krwCost: bigdecimal.BigDecimal;
  // public krwPerUnit: bigdecimal.BigDecimal;
  public quotCstId: string;
  public crgoSeq: number;
  public tempChargeWm: bigdecimal.BigDecimal;

  private _subTtlCrncyCd: string;
  public subTtlCost: number;
  private _ttlCrncyCd: string;
  public ttlCost: number;

  constructor(cstTp: number, reqNo: string, crgoSeq?: number) {
    this.cstTp = cstTp;
    this.reqNo = reqNo;
    if (crgoSeq != null && crgoSeq != undefined) this.crgoSeq = crgoSeq;
  }

  getCnsltnQuotSaveData() {
    return {
      reqNo: this.reqNo,
      itemCd: this.itemCd,
      itemNm: this.itemNm,
      itemUnit: this.itemUnit,
      cstTp: this.cstTp,
      crncyCd: this.crncyCd,
      unitCost:
        String(this.unitCost).replace(/,/gi, "").length <= 0
          ? null
          : Number(String(this.unitCost).replace(/,/gi, "")),
      other: this.other,
      chargeWm:
        String(this.chargeWm).replace(/,/gi, "").length <= 0
          ? null
          : Number(String(this.chargeWm).replace(/,/gi, "")),
      minUnitCost:
        String(this.minUnitCost).replace(/,/gi, "").length <= 0
          ? null
          : Number(String(this.minUnitCost).replace(/,/gi, "")),
      quotCstId: this.quotCstId,
      crgoSeq: this.crgoSeq,
    };
  }

  set subTtlCrncyCd(crncyCd: string) {
    if (this._subTtlCrncyCd == crncyCd) return;
    this._subTtlCrncyCd = crncyCd;
    if (this.crncyCd == crncyCd && this.cost && this.cost.doubleValue)
      this.subTtlCost = this.cost.doubleValue();
    else this.subTtlCost = null;
  }

  get subTtlCrncyCd() {
    return this._subTtlCrncyCd;
  }

  set ttlCrncyCd(crncyCd: string) {
    if (this._ttlCrncyCd == crncyCd) return;
    this._ttlCrncyCd = crncyCd;
    if (this.crncyCd == crncyCd && this.cost && this.cost.doubleValue)
      this.ttlCost = this.cost.doubleValue();
    else this.ttlCost = null;
  }

  get ttlCrncyCd() {
    return this._ttlCrncyCd;
  }
}

export class CstSubTotalModel {
  public fareTypNm: string;
  // public crncyRateList: Array<CrncyRateModel>;
  // public crncyRateListSelected: Array<any>;
  public totalCost: bigdecimal.BigDecimal;
  // public totalCostKrw: bigdecimal.BigDecimal;
  // public krwPerUnit: bigdecimal.BigDecimal;
  public cntryCd: string;
  public stndDt: string;
  public temp: string;
  public crncyCd: string;
}

export class CstGrpModel {
  public cstTp: number = -1;
  public cstTpNm: string = "";
  public cstLst: Array<CstModel> = new Array<CstModel>();
}

export class CstModel {
  public itemNm: string = "";
  public cost: bigdecimal.BigDecimal;
  public crncyCd: string = "";
  public itemUnit: string = "";
  public other: string = "";
  public itemCd: number;

  constructor(
    itemNm: string,
    cost: bigdecimal.BigDecimal,
    crncyCd: string,
    itemUnit: string,
    other
  ) {
    this.itemNm = itemNm;
    this.cost = cost;
    this.itemUnit = itemUnit;
    this.crncyCd = crncyCd;
    this.other = other;
  }
}

export class CnsltnQuotModel {
  public quotNo: string;
  public reqNo: string;
  public srtSeq: number;
  public quotTp: number;
  public quotTpNm: string;
  public forwarder: string;
  public person: string;
  public wrtDt: string;
  public orgCrncyCd: string;
  public transCrncyCd: string;
  public desCrncyCd: string;
  public totalCrncyCd: string;
  public exptDys: number;
  public arrEta: string;
  public quotStndWght: number;
  public linerCd: string;
  public linerNm: string;
  public transNm: string;
  public availDt: string;
  public cstLst: Array<any>;
  public stusCd: number;
  public stusCdNm: string;
  public summary: SummaryModel;
  public totalCost: bigdecimal.BigDecimal;
  public orgSubTotalCost: bigdecimal.BigDecimal;
  public desSubTotalCost: bigdecimal.BigDecimal;
  public transSubTotalCost: bigdecimal.BigDecimal;
  public wrtDtTypeDate: Date;
  public availDtTypeDate: Date;
  public fwdrCorpId: number;
  public quotRouteList: Array<any>;
}

export class SummaryModel {
  public crncyIndexMap: any;
  public crncyRateStndDt: string;
  public sumCostList: Array<any>;
  public totalCost: Array<any>;
}

export class GridTransRouteFare {
  isUpdate: boolean = false;

  activityYn: string = "Y";
  fareTransId: number;
  corp: FareCorp;
  orgLocation: Location;
  desLocation: Location;
  transTp: number;
  crgoTp: number;
  line: Line;
  lineCd: string;
  crncyCd: string;
  tsYn: string = "N";
  incOrgThcYn: string = "N";
  incDesThcYn: string = "N";
  availStrDt: string;
  availEndDt: string;
  insUserId: number;
  insDtm: Date;
  baseFareId: number;
  quotNo: string;

  cntr20CostId?: number;
  cntr20Cost?: bigdecimal;
  cntr40CostId?: number;
  cntr40Cost?: bigdecimal;
  cntrHcCostId?: number;
  cntrHcCost?: bigdecimal;

  cbmCostId?: number;
  cbmCost?: bigdecimal;
  minCostId?: number;
  minCost?: bigdecimal;

  kgCostId?: number;
  kgCost?: bigdecimal;
  air45CostId?: number;
  air45Cost?: bigdecimal;
  air100CostId?: number;
  air100Cost?: bigdecimal;
  air250CostId?: number;
  air250Cost?: bigdecimal;
  air300CostId?: number;
  air300Cost?: bigdecimal;
  air500CostId?: number;
  air500Cost?: bigdecimal;
  air1000CostId?: number;
  air1000Cost?: bigdecimal;

  constructor(fare?: RouteFareTrans) {
    if (!fare) return;

    this.activityYn = fare.status == RouteFareStatus.ACTIVE ? "Y" : "N";
    this.fareTransId = fare.fareTransId;
    this.corp = fare.corp;
    this.orgLocation = fare.orgLocation;
    this.desLocation = fare.desLocation;
    this.transTp = fare.transTp;
    this.crgoTp = fare.crgoTp;
    this.lineCd = fare.lineCd;
    this.crncyCd = fare.crncyCd;
    this.tsYn = fare.tsYn == 1 ? "T/S" : "DIRECT";
    this.incOrgThcYn = fare.incOrgThcYn == 1 ? "Y" : "N";
    this.incDesThcYn = fare.incDesThcYn == 1 ? "Y" : "N";
    this.availStrDt = fare.availStrDt;
    this.availEndDt = fare.availEndDt;
    this.insUserId = fare.insUserId;
    this.insDtm = moment(fare.insDtm).format("YYYYMMDDHHmm");
    this.baseFareId = fare.baseFareId;
    this.quotNo = fare.quotNo;

    this.cntr20CostId = fare.cntr20CostId;
    this.cntr20Cost = fare.cntr20Cost;
    this.cntr40CostId = fare.cntr40CostId;
    this.cntr40Cost = fare.cntr40Cost;
    this.cntrHcCostId = fare.cntrHcCostId;
    this.cntrHcCost = fare.cntrHcCost;

    this.cbmCostId = fare.cbmCostId;
    this.cbmCost = fare.cbmCost;
    this.minCostId = fare.minCostId;
    this.minCost = fare.minCost;

    this.kgCostId = fare.kgCostId;
    this.kgCost = fare.kgCost;
    this.air45CostId = fare.air45CostId;
    this.air45Cost = fare.air45Cost;
    this.air100CostId = fare.air100CostId;
    this.air100Cost = fare.air100Cost;
    this.air250CostId = fare.air250CostId;
    this.air250Cost = fare.air250Cost;
    this.air300CostId = fare.air300CostId;
    this.air300Cost = fare.air300Cost;
    this.air500CostId = fare.air500CostId;
    this.air500Cost = fare.air500Cost;
    this.air1000CostId = fare.air1000CostId;
    this.air1000Cost = fare.air1000Cost;
  }

  getFare(): RouteFareTrans {
    let fare: RouteFareTrans = new RouteFareTrans();

    fare.status =
      this.activityYn == "Y"
        ? RouteFareStatus.ACTIVE
        : RouteFareStatus.DEACTIVE;
    fare.fareTransId = this.fareTransId;
    fare.corp = this.corp;
    if (fare.corp) fare.corpId = this.corp.corpId;
    fare.orgLocation = this.orgLocation;
    if (fare.orgLocation) fare.orgLocationId = fare.orgLocation.locationId;
    fare.desLocation = this.desLocation;
    if (fare.desLocation) fare.desLocationId = fare.desLocation.locationId;
    fare.transTp = this.transTp;
    fare.crgoTp = this.crgoTp;
    fare.lineCd = this.lineCd;
    if (!fare.lineCd && this.line) fare.lineCd = this.line.lineCd;
    fare.crncyCd = this.crncyCd;
    fare.tsYn = this.tsYn == "T/S" ? 1 : 0;
    fare.incOrgThcYn = this.incOrgThcYn == "Y" ? 1 : 0;
    fare.incDesThcYn = this.incDesThcYn == "Y" ? 1 : 0;
    fare.availStrDt = this.availStrDt;
    fare.availEndDt = this.availEndDt;
    fare.insUserId = this.insUserId;
    fare.baseFareId = this.baseFareId;
    fare.quotNo = this.quotNo;

    fare.cntr20CostId = this.cntr20CostId;
    fare.cntr20Cost = this.cntr20Cost;
    fare.cntr40CostId = this.cntr40CostId;
    fare.cntr40Cost = this.cntr40Cost;
    fare.cntrHcCostId = this.cntrHcCostId;
    fare.cntrHcCost = this.cntrHcCost;

    fare.cbmCostId = this.cbmCostId;
    fare.cbmCost = this.cbmCost;
    fare.minCostId = this.minCostId;
    fare.minCost = this.minCost;

    fare.kgCostId = this.kgCostId;
    fare.kgCost = this.kgCost;
    fare.air45CostId = this.air45CostId;
    fare.air45Cost = this.air45Cost;
    fare.air100CostId = this.air100CostId;
    fare.air100Cost = this.air100Cost;
    fare.air250CostId = this.air250CostId;
    fare.air250Cost = this.air250Cost;
    fare.air300CostId = this.air300CostId;
    fare.air300Cost = this.air300Cost;
    fare.air500CostId = this.air500CostId;
    fare.air500Cost = this.air500Cost;
    fare.air1000CostId = this.air1000CostId;
    fare.air1000Cost = this.air1000Cost;

    return fare;
  }

  init(
    orgLocation: Location,
    desLocation: Location,
    transType: TransType,
    corp: FareCorp,
    tsYn: string,
    line?: Line
  ) {
    this.crncyCd = "USD";
    this.orgLocation = orgLocation;
    this.desLocation = desLocation;

    if (transType == TransType.FCL) {
      this.transTp = 0;
      this.crgoTp = 0;
    } else if (transType == TransType.LCL) {
      this.transTp = 0;
      this.crgoTp = 1;
    } else if (transType == TransType.AIR) {
      this.transTp = 1;
      this.crgoTp = 1;
    }

    if (line) {
      this.line = line;
      this.lineCd = line.lineCd;
    }

    this.tsYn = tsYn;
    this.corp = corp;
  }

  isEditable(corpId: number): boolean {
    return this.corp && this.corp.corpId && this.corp.corpId == corpId;
  }
}

export class GridIncidRouteFare {
  isUpdate: boolean = false;

  activityYn: string = "Y";
  fareIncidId: number;
  location: Location;
  costTp: number = 0;
  corp: FareCorp;
  transTp: number;
  crgoTp: number;
  item: CostItemModel;
  itemCd: string;
  crncyCd: string;
  insUserId: number;
  insDtm: Date;
  fareIncidReqId: number;

  cntr20CostId: number;
  cntr20Cost: bigdecimal;

  cntr40CostId: number;
  cntr40Cost: bigdecimal;

  cntrHcCostId: number;
  cntrHcCost: bigdecimal;

  blCostId: number;
  blCost: bigdecimal;

  cbmCostId: number;
  cbmCost: bigdecimal;

  kgCostId: number;
  kgCost: bigdecimal;

  awbCostId: number;
  awbCost: bigdecimal;

  constructor(fare?: RouteFareIncid) {
    if (!fare) return;

    this.activityYn = fare.status == RouteFareStatus.ACTIVE ? "Y" : "N";
    this.fareIncidId = fare.fareIncidId;
    this.location = fare.location;
    this.costTp = fare.costTp;
    this.corp = fare.corp;
    this.transTp = fare.transTp;
    this.crgoTp = fare.crgoTp;
    this.item = fare.item;
    this.itemCd = fare.itemCd;
    this.crncyCd = fare.crncyCd;
    this.insUserId = fare.insUserId;
    this.insDtm = moment(fare.insDtm).format("YYYYMMDDHHmm");
    this.fareIncidReqId = fare.fareIncidReqId;

    this.cntr20CostId = fare.cntr20CostId;
    this.cntr20Cost = fare.cntr20Cost;

    this.cntr40CostId = fare.cntr40CostId;
    this.cntr40Cost = fare.cntr40Cost;

    this.cntrHcCostId = fare.cntrHcCostId;
    this.cntrHcCost = fare.cntrHcCost;

    this.blCostId = fare.blCostId;
    this.blCost = fare.blCost;

    this.cbmCostId = fare.cbmCostId;
    this.cbmCost = fare.cbmCost;

    this.kgCostId = fare.kgCostId;
    this.kgCost = fare.kgCost;

    this.awbCostId = fare.awbCostId;
    this.awbCost = fare.awbCost;
  }

  getFare(): RouteFareIncid {
    let fare: RouteFareIncid = new RouteFareIncid();
    fare.fareIncidId = this.fareIncidId;
    fare.location = this.location;
    if (fare.location) fare.locationId = fare.location.locationId;
    fare.costTp = this.costTp;
    fare.corp = this.corp;
    if (fare.corp) fare.corpId = fare.corp.corpId;
    fare.transTp = this.transTp;
    fare.crgoTp = this.crgoTp;
    fare.item = this.item;
    if (fare.item) fare.itemCd = fare.item.itemCd;
    fare.crncyCd = this.crncyCd;
    fare.status =
      this.activityYn == "Y"
        ? RouteFareStatus.ACTIVE
        : RouteFareStatus.DEACTIVE;
    fare.fareIncidReqId = this.fareIncidReqId;

    fare.cntr20CostId = this.cntr20CostId;
    fare.cntr20Cost = this.cntr20Cost;

    fare.cntr40CostId = this.cntr40CostId;
    fare.cntr40Cost = this.cntr40Cost;

    fare.cntrHcCostId = this.cntrHcCostId;
    fare.cntrHcCost = this.cntrHcCost;

    fare.blCostId = this.blCostId;
    fare.blCost = this.blCost;

    fare.cbmCostId = this.cbmCostId;
    fare.cbmCost = this.cbmCost;

    fare.kgCostId = this.kgCostId;
    fare.kgCost = this.kgCost;

    fare.awbCostId = this.awbCostId;
    fare.awbCost = this.awbCost;

    return fare;
  }

  init(
    location: Location,
    transType: TransType,
    corp: FareCorp,
    item?: CostItemModel
  ) {
    this.location = location;
    this.crncyCd = "USD";
    this.corp = corp;

    if (item) {
      this.item = item;
      this.itemCd = item.itemCd;
    }

    if (transType == TransType.FCL) {
      this.transTp = 0;
      this.crgoTp = 0;
    } else if (transType == TransType.LCL) {
      this.transTp = 0;
      this.crgoTp = 1;
    } else if (transType == TransType.AIR) {
      this.transTp = 1;
      this.crgoTp = 1;
    }
  }
}

export class RouteFareTrans {
  fareTransId: number;
  corp: FareCorp;
  corpId: number;
  orgLocation: Location;
  orgLocationId: number;
  desLocation: Location;
  desLocationId: number;
  transTp: number;
  crgoTp: number;
  lineCd: string;
  crncyCd: string;
  tsYn: number = 0;
  incOrgThcYn: number = 0;
  incDesThcYn: number = 0;
  availStrDt: string;
  availEndDt: string;
  status: RouteFareStatus;
  insUserId: number;
  insDtm: Date;
  baseFareId: number;
  quotNo: string;

  cntr20CostId?: number;
  cntr20Cost?: bigdecimal;
  cntr40CostId?: number;
  cntr40Cost?: bigdecimal;
  cntrHcCostId?: number;
  cntrHcCost?: bigdecimal;

  cbmCostId?: number;
  cbmCost?: bigdecimal;
  minCostId?: number;
  minCost?: bigdecimal;

  kgCostId?: number;
  kgCost?: bigdecimal;
  air45CostId?: number;
  air45Cost?: bigdecimal;
  air100CostId?: number;
  air100Cost?: bigdecimal;
  air250CostId?: number;
  air250Cost?: bigdecimal;
  air300CostId?: number;
  air300Cost?: bigdecimal;
  air500CostId?: number;
  air500Cost?: bigdecimal;
  air1000CostId?: number;
  air1000Cost?: bigdecimal;
}

export class RouteFareIncid {
  fareIncidId: number;
  location: Location;
  locationId: number;
  costTp: number;
  corp: FareCorp;
  corpId: number;
  transTp: number;
  crgoTp: number;
  item: CostItemModel;
  itemCd: string;
  crncyCd: string;
  status: RouteFareStatus;
  insUserId: number;
  insDtm: Date;
  fareIncidReqId: number;

  cntr20CostId: number;
  cntr20Cost: bigdecimal;

  cntr40CostId: number;
  cntr40Cost: bigdecimal;

  cntrHcCostId: number;
  cntrHcCost: bigdecimal;

  blCostId: number;
  blCost: bigdecimal;

  cbmCostId: number;
  cbmCost: bigdecimal;

  kgCostId: number;
  kgCost: bigdecimal;

  awbCostId: number;
  awbCost: bigdecimal;
}

export class RouteFareIncidReqGrp {
  fareIncidReqGrpId: number;
  corp: FareCorp;
  corpId: number;
  location: Location;
  locationId: number;
  costTp: number;
  transTp: number;
  crgoTp: number;
  status: RouteFareCostReqStatus;
  insDtm: Date;

  fareIncidReqList: RouteFareIncidReq[];
}

export class RouteFareIncidReq {
  fareIncidReqId: number;
  itemCd: string;
  itemNm: string;
  crncyCd: string;
  baseFareCostId: number;

  cntr20CostId: number;
  cntr20Cost: bigdecimal;

  cntr40CostId: number;
  cntr40Cost: bigdecimal;

  cntrHcCostId: number;
  cntrHcCost: bigdecimal;

  blCostId: number;
  blCost: bigdecimal;

  cbmCostId: number;
  cbmCost: bigdecimal;

  kgCostId: number;
  kgCost: bigdecimal;

  awbCostId: number;
  awbCost: bigdecimal;
}

export class FareCorp {
  corpId: number;
  type: string;
  corpRegNo: string;
  corpNm: string;
  logoFile: string;
  statusCd: number;
  statusNm: string;
  fare: number;
}

export class CallBack<T> {
  beforeReq: () => void;
  onSccess: (T) => void;
  onComplete: () => void;
  onFail: (ResponseModel) => void;
}

export class TransFareConditionModel {
  orgLocationList: number[] = [];
  desLocationList: number[] = [];
  curPage: number = 0;
}

export class IncidFareConditionModel {
  locationList: number[] = [];
  curPage?: number = 0;
}

export enum TransType {
  FCL,
  LCL,
  AIR,
}

export enum RouteFareStatus {
  ACTIVE = "ACTIVE",
  DEACTIVE = "DEACTIVE",
  DEL = "DEL",
}

export enum RouteFareCostReqStatus {
  NEW = "NEW",
  DEL = "DEL",
  CHECKED = "CHECKED",
}

export class FareTrans {
  fareId: number;

  activityYn: number = 0;
  del: boolean = false;

  orgLocation: Location;
  desLocation: Location;

  transTp: number;
  crgoTp: number;
  lineCd: string;
  itemCd: string;
  itemNm: string;
  crncyCd: string;
  tsYn: number;
  incOrgThcYn: number;
  incDesThcYn: number;
  availStrDt: string;
  availEndDt: string;
  insDtm: Date;
  updDtm: Date;

  cntr20CostId?: number;
  cntr20Cost?: bigdecimal;
  cntr40CostId?: number;
  cntr40Cost?: bigdecimal;
  cntrHcCostId?: number;
  cntrHcCost?: bigdecimal;

  cbmCostId?: number;
  cbmCost?: bigdecimal;
  minCostId?: number;
  minCost?: bigdecimal;

  kgCostId?: number;
  kgCost?: bigdecimal;
  air45CostId?: number;
  air45Cost?: bigdecimal;
  air100CostId?: number;
  air100Cost?: bigdecimal;
  air250CostId?: number;
  air250Cost?: bigdecimal;
  air300CostId?: number;
  air300Cost?: bigdecimal;
  air500CostId?: number;
  air500Cost?: bigdecimal;
  air1000CostId?: number;
  air1000Cost?: bigdecimal;
}

export class FareIncid {
  orgFareId: number;
  desFareId: number;

  activityYn: number = 0;
  del: boolean = false;

  location: Location;
  transTp: number;
  crgoTp: number;
  itemCd: string;
  itemNm: string;
  crncyCd: string;

  orgInsDtm: Date;
  orgUpdDtm: Date;
  desInsDtm: Date;
  desUpdDtm: Date;

  orgCntr20CostId?: number;
  orgCntr20Cost?: bigdecimal;
  orgCntr40CostId?: number;
  orgCntr40Cost?: bigdecimal;
  orgCntrHcCostId?: number;
  orgCntrHcCost?: bigdecimal;
  orgBlCostId?: number;
  orgBlCost?: bigdecimal;
  orgCbmCostId?: number;
  orgCbmCost?: bigdecimal;
  orgKgCostId?: number;
  orgKgCost?: bigdecimal;
  orgAwbCostId?: number;
  orgAwbCost?: bigdecimal;

  desCntr20CostId?: number;
  desCntr20Cost?: bigdecimal;
  desCntr40CostId?: number;
  desCntr40Cost?: bigdecimal;
  desCntrHcCostId?: number;
  desCntrHcCost?: bigdecimal;
  desBlCostId?: number;
  desBlCost?: bigdecimal;
  desCbmCostId?: number;
  desCbmCost?: bigdecimal;
  desKgCostId?: number;
  desKgCost?: bigdecimal;
  desAwbCostId?: number;
  desAwbCost?: bigdecimal;
}

export class GridTransFareModel {
  isDel: boolean = false;
  isUpdate: boolean = false;

  fareId: number;
  transTp: number;
  crgoTp: number;
  itemCd: string;
  itemNm: string;

  activityYn: string = "N";
  orgLocation: Location;
  desLocation: Location;
  line: Line;
  lineCd: string;
  tsYn: string;
  incOrgThcYn: string;
  incDesThcYn: string;
  crncyCd: string;
  availStrDt: string;
  availEndDt: string;
  insDtm: string;

  cntr20CostId?: number;
  cntr20Cost?: bigdecimal;
  cntr40CostId?: number;
  cntr40Cost?: bigdecimal;
  cntrHcCostId?: number;
  cntrHcCost?: bigdecimal;

  cbmCostId?: number;
  cbmCost?: bigdecimal;
  minCostId?: number;
  minCost?: bigdecimal;

  kgCostId?: number;
  kgCost?: bigdecimal;
  air45CostId?: number;
  air45Cost?: bigdecimal;
  air100CostId?: number;
  air100Cost?: bigdecimal;
  air250CostId?: number;
  air250Cost?: bigdecimal;
  air300CostId?: number;
  air300Cost?: bigdecimal;
  air500CostId?: number;
  air500Cost?: bigdecimal;
  air1000CostId?: number;
  air1000Cost?: bigdecimal;

  constructor(fare: FareTrans) {
    this.fareId = fare.fareId;
    this.transTp = fare.transTp;
    this.crgoTp = fare.crgoTp;
    this.itemCd = fare.itemCd;
    this.itemNm = fare.itemNm;

    this.activityYn = fare.activityYn ? "Y" : "N";
    this.isDel = fare.del;

    this.orgLocation = fare.orgLocation;
    this.desLocation = fare.desLocation;
    this.lineCd = fare.lineCd;
    this.tsYn = fare.tsYn == 1 ? "T/S" : "Direct";
    this.incOrgThcYn = fare.incOrgThcYn == 1 ? "Y" : "N";
    this.incDesThcYn = fare.incDesThcYn == 1 ? "Y" : "N";
    this.crncyCd = fare.crncyCd;

    this.cntr20CostId = fare.cntr20CostId;
    this.cntr20Cost = fare.cntr20Cost;
    this.cntr40CostId = fare.cntr40CostId;
    this.cntr40Cost = fare.cntr40Cost;
    this.cntrHcCostId = fare.cntrHcCostId;
    this.cntrHcCost = fare.cntrHcCost;

    this.cbmCostId = fare.cbmCostId;
    this.cbmCost = fare.cbmCost;
    this.minCostId = fare.minCostId;
    this.minCost = fare.minCost;

    this.kgCostId = fare.kgCostId;
    this.kgCost = fare.kgCost;
    this.air45CostId = fare.air45CostId;
    this.air45Cost = fare.air45Cost;
    this.air100CostId = fare.air100CostId;
    this.air100Cost = fare.air100Cost;
    this.air250CostId = fare.air250CostId;
    this.air250Cost = fare.air250Cost;
    this.air300CostId = fare.air300CostId;
    this.air300Cost = fare.air300Cost;
    this.air500CostId = fare.air500CostId;
    this.air500Cost = fare.air500Cost;
    this.air1000CostId = fare.air1000CostId;
    this.air1000Cost = fare.air1000Cost;

    this.availStrDt = fare.availStrDt;
    this.availEndDt = fare.availEndDt;

    if (fare.updDtm || fare.insDtm)
      this.insDtm = moment(fare.updDtm || fare.insDtm).format("YYYYMMDDHHmm");
  }
}

export class GridIncidFareModel {
  isDel: boolean = false;
  isUpdate: boolean = false;

  orgFareId: number;
  desFareId: number;
  transTp: number;
  crgoTp: number;

  activityYn: string = "N";
  location: Location;
  item: CostItemModel;
  crncyCd: string;

  orgInsDtm: string;
  desInsDtm: string;

  orgCntr20CostId?: number;
  orgCntr20Cost?: bigdecimal;
  orgCntr40CostId?: number;
  orgCntr40Cost?: bigdecimal;
  orgCntrHcCostId?: number;
  orgCntrHcCost?: bigdecimal;
  orgBlCostId?: number;
  orgBlCost?: bigdecimal;
  orgCbmCostId?: number;
  orgCbmCost?: bigdecimal;
  orgKgCostId?: number;
  orgKgCost?: bigdecimal;
  orgAwbCostId?: number;
  orgAwbCost?: bigdecimal;

  desCntr20CostId?: number;
  desCntr20Cost?: bigdecimal;
  desCntr40CostId?: number;
  desCntr40Cost?: bigdecimal;
  desCntrHcCostId?: number;
  desCntrHcCost?: bigdecimal;
  desBlCostId?: number;
  desBlCost?: bigdecimal;
  desCbmCostId?: number;
  desCbmCost?: bigdecimal;
  desKgCostId?: number;
  desKgCost?: bigdecimal;
  desAwbCostId?: number;
  desAwbCost?: bigdecimal;

  constructor(fare: FareIncid) {
    this.isDel = fare.del;
    this.isUpdate = false;

    this.orgFareId = fare.orgFareId;
    this.desFareId = fare.desFareId;
    this.transTp = fare.transTp;
    this.crgoTp = fare.crgoTp;

    this.activityYn = fare.activityYn ? "Y" : "N";
    this.location = fare.location;

    if (fare.itemCd) {
      this.item = new CostItemModel();
      this.item.itemCd = fare.itemCd;
      this.item.itemNm = fare.itemNm;
    }
    this.crncyCd = fare.crncyCd;

    if (fare.orgUpdDtm || fare.orgInsDtm)
      this.orgInsDtm = moment(fare.orgUpdDtm || fare.orgInsDtm).format(
        "YYYYMMDDHHmm"
      );
    if (fare.desUpdDtm || fare.desInsDtm)
      this.desInsDtm = moment(fare.desUpdDtm || fare.desInsDtm).format(
        "YYYYMMDDHHmm"
      );

    this.orgCntr20CostId = fare.orgCntr20CostId;
    this.orgCntr20Cost = fare.orgCntr20Cost;
    this.orgCntr40CostId = fare.orgCntr40CostId;
    this.orgCntr40Cost = fare.orgCntr40Cost;
    this.orgCntrHcCostId = fare.orgCntrHcCostId;
    this.orgCntrHcCost = fare.orgCntrHcCost;
    this.orgBlCostId = fare.orgBlCostId;
    this.orgBlCost = fare.orgBlCost;
    this.orgCbmCostId = fare.orgCbmCostId;
    this.orgCbmCost = fare.orgCbmCost;
    this.orgKgCostId = fare.orgKgCostId;
    this.orgKgCost = fare.orgKgCost;
    this.orgAwbCostId = fare.orgAwbCostId;
    this.orgAwbCost = fare.orgAwbCost;

    this.desCntr20CostId = fare.desCntr20CostId;
    this.desCntr20Cost = fare.desCntr20Cost;
    this.desCntr40CostId = fare.desCntr40CostId;
    this.desCntr40Cost = fare.desCntr40Cost;
    this.desCntrHcCostId = fare.desCntrHcCostId;
    this.desCntrHcCost = fare.desCntrHcCost;
    this.desBlCostId = fare.desBlCostId;
    this.desBlCost = fare.desBlCost;
    this.desCbmCostId = fare.desCbmCostId;
    this.desCbmCost = fare.desCbmCost;
    this.desKgCostId = fare.desKgCostId;
    this.desKgCost = fare.desKgCost;
    this.desAwbCostId = fare.desAwbCostId;
    this.desAwbCost = fare.desAwbCost;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/fare.service.ts